<script lang="ts">
  import * as Card from '$lib/components/ui/card';
  import type { Writable } from 'svelte/store';
  import SeasonChart from './SeasonChart.svelte';
  import SeasonSummaryTable from './SeasonSummaryTable.svelte';
  import type { ChartView, Metric, Season, SigKey } from './seasons';

  export let title: string;
  export let seasons: Record<string, Season>;
  export let years: number[];
  export let metric: Metric;
  export let sigKey: SigKey | null = null;
  export let view: ChartView = 'load';
  export let startMonth: number;
  export let endMonth: number;
  export let distanceUnits = 'km';
  export let hover: Writable<{ x: number | null; from: string }>;
  export let checkpoint: Writable<number | null>;
</script>

<!-- border-border: this page isn't inside `.twp`, where Tailwind's base border colour is set, so the legacy
     stylesheet's `.border { border: 1px solid red }` would colour the card's border otherwise. -->
<!-- Chart and summary sit side by side on wide screens and stack on mobile. On wide screens the card and its content are
     subgrids of the page's two columns (see MySeasons.svelte), so every card's chart has the same width and the guides
     line up vertically between cards. -->
<Card.Root class="border-border xl:col-span-2 xl:grid xl:[grid-template-columns:subgrid]">
  <Card.Header class="p-4 pb-1 xl:col-span-2">
    <!-- m-0: the legacy stylesheet gives h3 a top margin. -->
    <Card.Title class="m-0 text-base">{title}</Card.Title>
  </Card.Header>
  <!-- xl:!(...) not xl:(...): this project's tailwind.config.js forces every utility to !important (to beat the
       legacy Bootstrap CSS), but that doesn't reach this arbitrary-property utility, so without the explicit !
       the unprefixed grid-cols-1 !important rule above always wins and subgrid never actually applies, at any width. -->
  <Card.Content class="grid grid-cols-1 items-start gap-4 p-4 pt-0 xl:col-span-2 xl:![grid-template-columns:subgrid]">
    <SeasonChart {seasons} {years} {metric} {sigKey} {view} {startMonth} {endMonth} {hover} {checkpoint} checkpointHint={metric === 'tl'} />
    <SeasonSummaryTable {seasons} {years} {metric} {sigKey} {distanceUnits} {checkpoint} />
  </Card.Content>
</Card.Root>
